import { inject, Injectable } from '@angular/core';
import { firstValueFrom, fromEvent, takeUntil } from 'rxjs';

import { HttpService } from '../shared/services/http.service';
import { GatewayListItem } from '../site-gateway/models/gateway';

import { DeviceMS } from './models/Device';
import { SetupId, SiteId } from './models/Site';

@Injectable({ providedIn: 'root' })
export class SiteDevicesGateway {
    private readonly httpService = inject(HttpService);

    getGateways(setupId: SetupId, abortSignal: AbortSignal): Promise<GatewayListItem[]> {
        return this.get(`/v1/site/${setupId}/gateways`, abortSignal);
    }

    getDevices(siteId: SiteId, abortSignal: AbortSignal): Promise<DeviceMS[]> {
        return this.get(`/v1/site/${siteId}/devices?synch=true`, abortSignal);
    }

    /** The devices as the backend last recorded them, without asking the boxes. */
    getRecordedDevices(siteId: SiteId): Promise<DeviceMS[]> {
        return firstValueFrom(this.httpService.get(`/v1/site/${siteId}/devices?synch=false`));
    }

    /** Aborting cancels the request; the promise then rejects. */
    private get<T>(url: string, abortSignal: AbortSignal): Promise<T> {
        return firstValueFrom(this.httpService.get(url).pipe(takeUntil(fromEvent(abortSignal, 'abort'))));
    }
}
